// Lazy-load mermaid (the heavy `vendor-diagram` chunk) only when a diagram
// actually renders, instead of statically importing it into every bundle that
// shows a chat. Initialized exactly once via a module-level guard; a rejected
// chunk-load is NOT cached, so a later render can retry.
let mermaidPromise: Promise<typeof import("mermaid").default> | null = null;

export const loadMermaid = () => {
  if (!mermaidPromise) {
    mermaidPromise = import("mermaid")
      .then((m) => {
        m.default.initialize({ startOnLoad: false, theme: "neutral" });
        return m.default;
      })
      .catch((e) => {
        // Don't cache a failed chunk-load — let a later render retry.
        mermaidPromise = null;
        throw e;
      });
  }
  return mermaidPromise;
};
